import { createTheme } from '@mui/material/styles';
import type { } from '@mui/lab/themeAugmentation';

const theme = createTheme({
  palette: {
    primary: {
      main: '#3b82f6',
    },
    secondary: {
      main: '#64748b',
    },
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    }
  },
});

export default theme;
